(function () {
  'use strict';

  angular
    .module('vcdms.vcprinter')
    .config(config);
  
  config.$inject = ['$stateProvider', '$logProvider'];
  
  function config($stateProvider, $log) {
    $stateProvider
      .state('playground.vcdmsprinter', {
        url: '/vcdmsprinter',
        views: {
          'playgroundmain@playground': {
            template: `
              <h3 class="alert alert-info"><tt>&lt;printersearch printer="" printerref="" editinplace="true"&gt;</tt></h3><div ui-view="printersearchview"></div>
              <h3 class="alert alert-info"><tt>&lt;printersearch printer="" printerref="" parentsave=""&gt;</tt></h3><div ui-view="printersearchview2"></div>
              <h3 class="alert alert-info"><tt>&lt;printereditor printer="" mode="" onClose=""&gt;</tt></h3><div ui-view="printereditview"></div>
              <h3 class="alert alert-info"><tt>&lt;printernew&gt;</tt></h3><div ui-view="printernewview"></div>
              <h3 class="alert alert-info"><tt>&lt;printerlist printers="?"&gt;</tt></h3><div ui-view="printerlistview"></div>
            `
          }
        },
        onEnter: function () {
          $log.debug('debug/routes - playground.vcdmsvcprinter entered');
        }
      });
    
    
    $stateProvider
      .state('playground.vcdmsprinter.allcomponents', {
        url: '/allcomponents',
        resolve: {
          printer: function () {
            return '';
          },
          printerref: function () {
            return '';
          },
          someprinter: function (Printer) {
            return Printer.$find('572b31b07c01597e3e150923');
          },
          allprinters: function (Printer) {
            return Printer.$search({active: true});
          },
          parentsavesearch: function () {
            return function (printer, printerref) {
              console.log('debug: dummy parentsave called for printersearch with: ', printer, printerref);
            };
          },
          eip: function () {
            return true;
          }
        },
        views: {
          // When `fooState.barState` is active, `fooComponent`
          // is loaded into the <ui-view name='content' />
          // which was created by `fooState`.
          // The component's `foo` input receives `fooData` resolve
          'printersearchview@playground.vcdmsprinter': {
            component: 'printersearch',
            bindings: {
              printer: 'printer',
              printerref: 'printerref',
              editinplace: 'eip'
            }
          },
          'printersearchview2@playground.vcdmsprinter': {
            component: 'printersearch',
            bindings: {
              printer: 'printer',
              printerref: 'printerref',
              parentsave: 'parentsavesearch'
            }
          },
          'printereditview@playground.vcdmsprinter': {
            component: 'printereditor',
            bindings: {
              printer: 'someprinter'
            }
          },
          'printernewview@playground.vcdmsprinter': {
            component: 'printernew',
            bindings: {
            }
          },
          'printerlistview@playground.vcdmsprinter': {
            component: 'printerlist',
            bindings: {
              printers: 'allprinters'
            }
          }
        },
        onEnter: function () {
          console.log('playground.vcdmsprinter.allcomponents entered');
        }
      });
    
    
  }// all routes
  
  
}());
